import tippy from 'tippy.js';
import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
import GLightbox from "glightbox";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
const axios = require('axios').default;
import { carouselWrapper } from "./helpers/CarouselWrapper";
import Choices from "choices.js";
import gsap from "gsap";
import flatpickr from "flatpickr";
// GDPR Custom System
require('./helpers/CookieConsent');
$(document).ready(function () {
    if ($(".page-template-tpl-agenda").length) {
        flatpickr(".date-picker", {
            // disableMobile: "true",
            altFormat: "d.m.Y",
            altInput: true,
            dateFormat: "Ymd",
            onReady: () => {
                if ($('.date-picker.start').val() == "")
                    $(".date-picker.start.flatpickr-input:not([type=hidden])").attr("type", "text");
                if ($('.date-picker.end').val() == "")
                    $(".date-picker.end.flatpickr-input:not([type=hidden])").attr("type", "text");
            },
            disableMobile: true
        });
    }
    $("body").on("click", ".offer-item .header a", (e) => {
        e.preventDefault();
        $(e.currentTarget).parent().parent().next(".text").slideToggle(250);
        $(e.currentTarget).toggleClass("open");
    });
    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 250
    });
    $('.tippyelm').each((k, v) => {
        tippy(v, {
            placement: 'left',
            content: $(v).attr("data-tippy"),
            followCursor: true,
            arrow: false,
            theme: 'light',
        });
    });
    let timelines = {};
    let inProgress = false;
    // $("#main-header").hover(() => {},()=>{
    //     $.each(timelines, (k,v)=> {
    //         console.log(k,v);
    //         if (v.completed == true) {
    //             v.element.trigger("mouseleave");
    //         }
    //     });
    // });
    let startHeight = $("#nav-main > .background").height();
    $(window).resize(() => {
        startHeight = $("#nav-main > .background").height();
    });
    $('.has-children').each((k, v) => {
        let name = "menu-" + k;
        let menu = v;
        timelines[name] = {
            completed: false,
            over: false,
            tl: null,
            element: null
        };
        $(menu).on("mouseover", (e) => {
            if ($(window).width() < 760)
                return false;
            if (!$(e.currentTarget).hasClass("over")) {
                $(e.currentTarget).addClass("over");
                let ul = $(e.currentTarget).children("ul").get(0);
                $(ul).show();
                let height = $(e.currentTarget).children("ul").outerHeight() + 60;
                inProgress = true;
                let htl = gsap.timeline({
                    paused: true,
                    onComplete: () => {
                        inProgress = false;
                        $(e.currentTarget).addClass("completed");
                        timelines[name].completed = true;
                        $(e.currentTarget).on("mouseleave", () => {
                            inProgress = true;
                            htl.reverse();
                        });
                    },
                    onReverseComplete: () => {
                        inProgress = false;
                        $(e.currentTarget).removeClass("over");
                        $(e.currentTarget).removeClass("completed");
                        timelines[name].over = false;
                        timelines[name].completed = false;
                        if (!$('.has-children').hasClass("over")) {
                            gsap.to("#main-header > .background", {
                                height: "95%",
                                duration: 0.3,
                                delay: 0.2
                            });
                            gsap.to("#main-header .bline-wrapper", {
                                opacity: 0,
                                duration: 0.01,
                                delay: 0.4
                            });
                            gsap.to("#main-header .bline", {
                                width: "0%",
                                duration: 0.4
                            });
                        }
                    }
                });
                gsap.to("#main-header > .background", {
                    height: height,
                    duration: 0.3,
                });
                gsap.to("#main-header .bline-wrapper", {
                    opacity: 1,
                    duration: 0.01
                });
                gsap.to("#main-header .bline", {
                    width: "100%",
                    duration: 0.4,
                    delay: 0.02
                });
                htl.to(ul, {
                    opacity: 1,
                    duration: 0.4,
                    top: 0
                });
                timelines[name].tl = htl;
                timelines[name].over = true;
                timelines[name].element = $(e.currentTarget);
                htl.play();
                $(e.currentTarget).on("mouseleave", () => {
                    inProgress = true;
                    htl.reverse();
                });
            }
        });
    });
    let menuTL = gsap.timeline({
        paused: true,
        duration: 0.05,
        onComplete: () => {
        },
        onReverseComplete: () => {
            // $(".switchers").removeClass("opened");
        }
    });
    let open = false;
    menuTL.to("#nav-main", {
        height: "100vh",
    })
        .to("#nav-main > ul > li", {
        top: 0,
        opacity: 1,
        duration: 0.05,
        stagger: 0.1
    });
    $('body').on("click", ".switchers .switcher", (e) => {
        $(".switchers").toggleClass("opened");
        e.preventDefault();
        if (!open) {
            open = true;
            menuTL.play();
        }
        else {
            open = false;
            menuTL.reverse();
        }
    });
    $('body').on("click", "#big-menu .close a", (e) => {
        e.preventDefault();
        $("#big-menu").fadeOut(250);
    });
    const lightbox = GLightbox({});
    carouselWrapper();
    $("body").on("click", "#more-filters", (e) => {
        e.preventDefault();
        // $(e.currentTarget).hide(0);
        // $("#simple-submit-button").hide(0);
        $("#properties-form").find(".second-level").slideToggle(250);
    });
    $("#properties-form select").each((e, v) => {
        let choices = new Choices(v, {
            removeItemButton: true,
            loadingText: 'Loading...',
            noResultsText: 'Aucun résultat trouvé',
            noChoicesText: 'Aucun choix disponible',
            itemSelectText: 'Presser pour séléctionner',
            uniqueItemText: 'Seulement une seule valeur peut etre ajoutée',
            shouldSort: false,
            // customAddItemText: 'Only values matching specific conditions can be added',
            addItemText: (value) => {
                return `Appuyez sur retour pour ajouter <b>"${value}"</b>`;
            },
            maxItemText: (maxItemCount) => {
                return `Seulement ${maxItemCount} valeurs peuvent être ajoutées.`;
            },
        });
    });
    $(".add-to-title").each((k, v) => {
        $(v).find("h1,h2,h3,h4").append("<span class='line'></span>");
    });
    $("body").on("click", ".opener", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("opened");
        $(e.currentTarget).parent().next().slideToggle(250);
    });
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            const posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    if (window.location.hash) {
        var node = $(window.location.hash);
        if (node.length) {
            const posY = $(node).offset().top - $("#main-header").height() - 50;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    }
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", (e) => {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", (e) => {
        e.preventDefault();
        const elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 200) {
            $('#logo').addClass('hide-text');
        }
        if ($(window).scrollTop() < 200) {
            $('#logo').removeClass('hide-text');
        }
    });
    $("body").on("click", "*[data-link]", (e) => {
        document.location = $(e.currentTarget).attr("data-link");
    });
});
